import React from 'react';

export const inpSt: React.CSSProperties = {
  background: 'var(--glass-bg-card)', border: '1px solid rgba(255,255,255,0.10)',
  borderRadius: 'var(--radius-card)', color: 'var(--color-text)',
  fontSize: 'var(--text-xs)', padding: '0.375rem 0.625rem', outline: 'none', width: '100%',
};

export const selSt: React.CSSProperties = {
  background: 'var(--glass-bg-card)', border: '1px solid rgba(255,255,255,0.10)',
  borderRadius: 'var(--radius-card)', color: 'var(--color-text)',
  fontSize: 'var(--text-xs)', padding: '0.375rem 0.5rem', outline: 'none', cursor: 'pointer', width: '100%',
};

export const iconBtnStyle: React.CSSProperties = {
  background: 'none', border: 'none', cursor: 'pointer',
  color: 'var(--color-text-muted)', padding: '0.25rem',
  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
};
